const marketResearchCareers = [

    {
        id: 19,
        slug: "market-research-junior-research-analyst",
        title: "Junior Research Analyst (JRA)",
        department: "Market Research",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Collect market and industry data from public sources",
                "Support preparation of market research reports",
                "Assist in competitor and industry landscape analysis",
                "Maintain research databases and data sheets",
                "Support senior analysts in preparing presentations"
            ],
            skills: [
                "Basic research and analytical skills",
                "Excel and PowerPoint fundamentals",
                "Attention to detail",
                "Ability to organize and analyze data"
            ],
            experience: ["Fresher"],
            education: ["Bachelor’s degree in Business, Economics, Marketing, or Commerce"]
        }
    },

    {
        id: 20,
        slug: "research-analyst",
        title: "Research Analyst (RA)",
        department: "Market Research",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Conduct industry and market research",
                "Prepare market reports and research summaries",
                "Analyze competitor positioning and industry trends",
                "Support market sizing and growth analysis",
                "Assist in preparing client presentations and reports"
            ],
            skills: [
                "Market research techniques",
                "Data analysis and interpretation",
                "Excel and PowerPoint proficiency",
                "Analytical thinking"
            ],
            experience: ["0–1 years"],
            education: [
                "Bachelor’s degree in Business, Economics, Marketing, or Commerce",
                "MBA preferred"
            ]
        }
    },

    {
        id: 21,
        slug: "senior-research-analyst",
        title: "Senior Research Analyst (SRA)",
        department: "Market Research",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Lead market research and industry analysis projects",
                "Conduct market sizing and growth forecasting",
                "Prepare detailed market reports and insights",
                "Analyze industry trends and competitive landscape",
                "Support strategy and investment research assignments"
            ],
            skills: [
                "Market analysis and research frameworks",
                "Data interpretation and forecasting",
                "Strong analytical skills",
                "Report writing and presentation"
            ],
            experience: ["1–3 years"],
            education: [
                "Bachelor’s or Master’s degree in Business, Economics, Marketing, or related field",
                "MBA preferred"
            ]
        }
    },

    {
        id: 22,
        slug: "associate",
        title: "Associate",
        department: "Market Research",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Manage research workstreams for client projects",
                "Conduct market assessments and opportunity analysis",
                "Lead competitor and industry research initiatives",
                "Support strategy and consulting engagements",
                "Coordinate work between analysts and project teams"
            ],
            skills: [
                "Structured market research approach",
                "Data analysis and insight generation",
                "Project coordination",
                "Communication and presentation"
            ],
            experience: ["3+ years"],
            education: [
                "Bachelor’s or Master’s degree in Business, Economics, Marketing, or related field",
                "MBA preferred"
            ]
        }
    },

    {
        id: 23,
        slug: "senior-associate",
        title: "Senior Associate",
        department: "Market Research",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Lead research execution for complex market studies",
                "Review research reports and analytical outputs",
                "Prepare strategic insights and industry analysis",
                "Support consulting and advisory projects",
                "Guide junior analysts and associates"
            ],
            skills: [
                "Advanced market analysis",
                "Research leadership",
                "Strategic thinking",
                "Strong analytical skills"
            ],
            experience: ["5+ years"],
            education: [
                "Bachelor’s or Master’s degree in Business, Economics, Marketing, or related field",
                "MBA preferred"
            ]
        }
    }
];

export default marketResearchCareers;
